import BaseStore from './base-store.js'
import StoreProxy from './store_proxy.js'
import {API2_COMPANIES} from 'consts/api2.js'



import * as $utils from 'utils';
export class Company extends BaseStore {
  constructor(values = {}) {
    super({
      id: undefined,
      name: undefined,
      following: false,
      tracker_type: undefined,
      tracker_focus: undefined,
      tracker_alerts: undefined,
      focus_on: undefined,
      contacts: undefined,
      shared_company_id: undefined,
      logo_url: undefined,
      ...values
    })
  }

  get state_copy(){
    return $utils.object.deepCopy(this._state)
  }

  async doSave(rest, changed) {
    const to_write = {}
    for (const key of changed) to_write[key] = this._state[key]
    await rest.patch(`${API2_COMPANIES}/${this.id}`, to_write)
  }

  async drop(userId = undefined) {
    if (userId) {
      await this._rest.delete(`${API2_COMPANIES}/${this.id}?user_id=${userId}`)
      return
    }
    await this._rest.delete(`${API2_COMPANIES}/${this.id}`)
  }
  update(next){
    for (const key in next) {
      if (key === 'logo_url') {
        const new_val = next[key]?.split('?')[0]
        const prev_val = this._state[key]?.split('?')[0]
        if (new_val === prev_val) continue
      }
      if (key in this._state) {
        this._state[key] = next[key]
      }
    }
  }
}

class Companies extends BaseStore {
  constructor(values = {}) {
    super({
      companies: [],
      view_items: [],
      view_total: 0,
      total: 0,
      ...values
    })
  }

  async doLoad(rest, params) {
    const result = await rest.get(API2_COMPANIES, params)
    const existing_ids = new Set(this._state.view_items.map(i => i.id))
    this._state.view_items = result.view_items.map(
      data => existing_ids.has(data.id)
        ? this._updateItem(data)
        : new Company(data))
    this._state.view_total = result.view_total
    this._state.total = result.total
  }

  _updateItem(data){
    const company = this.getCompany(data.id)
    if (company) {
      company.update(data)
    }
    return company
  }
  getCompany(id) {
    return this._state.view_items.find(x => x.id === id)
  }
  deleteItem(id){
    this._state.view_items = this._state.view_items.filter(company => company.id !== id)
  }
  async loadCompany(id) {
    const json = await this._rest.get(`${API2_COMPANIES}/${id}`)
    return new Company(json)
  }
  async newCompany(params) {
    const data = await this._rest.put(API2_COMPANIES, params)
    return new Company(data)
  }
  async search(query) {
    return await this._rest.get(`${API2_COMPANIES}/search?query=${encodeURIComponent(query)}`)
  }
}

const companies = StoreProxy(new Companies(), {array_prop: 'view_items'})
export default companies
